"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Winner_1 = __importDefault(require("./Winner"));
var next_intl_1 = require("next-intl");
var useGeneratedTopWinners_1 = __importDefault(require("./useGeneratedTopWinners"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TopWinners = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)('translation');
    var topWinners = (0, useGeneratedTopWinners_1.default)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.topWinnersBlock },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.topWinnersTitle },
            react_1.default.createElement("img", { src: "/img/icons/topWinners.svg", alt: "top winners icon" }),
            t('topWinners')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.topWinnersContent }, topWinners.map(function (winner, idx) { return (react_1.default.createElement(Winner_1.default, { key: "winner".concat(idx), slug: winner === null || winner === void 0 ? void 0 : winner.slug, title: String(winner.GameName), playerName: String(winner.ScreenName) === String(winner.Email)
                ? t('anonymous')
                : String(winner.ScreenName), gameCardPlaceholder: gameCardPlaceholder, imageUrl: String(winner.Image), prize: "".concat(String(winner.AmountEUR), " ").concat(String(winner.Currency)), gameId: winner.ID })); }))));
};
exports.default = react_1.default.memo(TopWinners);
